import ERPExchangePlatformModal from './ERP_exchange_platform-modal.vue'
export default ERPExchangePlatformModal
